<!-- components/dashboard/cards/OrdemCard.vue -->
<template>
   <v-card
    class="ordem-card h-100"
    elevation="2"
    @click="$emit('selecionar', ordem)"
  >


    <!-- Header do Card -->
    <v-card-title class="pa-4 pb-2">
      <div class="d-flex align-center justify-space-between w-100">
        <div class="d-flex align-center">
          <v-chip
            color="primary"
            size="small"
            variant="outlined"
            class="mr-2"
          >
            ORDEM#{{ ordem.id_ordem  }}   ID#{{ ordem.id }}
          </v-chip>
          <v-chip
            :color="getCorStatus(ordem.status)"
            size="small"
          >
            {{ formatarStatus(ordem.status) }}
          </v-chip>
        </div>

        <!-- Indicadores -->
        <div class="d-flex align-center gap-1">
          <v-icon
            v-if="ordem.atrasada"
            color="error"
            size="20"
          >
            mdi-alert-circle
          </v-icon>
          <v-icon
            v-if="ordem.urgente"
            color="warning"
            size="20"
          >
            mdi-clock-alert
          </v-icon>
          <v-icon
            v-if="ordem.prioridade <= 3"
            color="error"
            size="20"
          >
            mdi-priority-high
          </v-icon>
        </div>
      </div>
    </v-card-title>

    <!-- Conteúdo Principal -->
    <v-card-text class="pa-4 pt-2">
      <!-- Cliente e Produto -->
      <div class="mb-3">
        <div class="text-h6 font-weight-bold mb-1">
          {{ ordem.cliente || 'Cliente não informado' }}
        </div>
        <div class="text-body-2 grey--text">
          {{ obterNomeProduto(ordem) }}
        </div>
      </div>


     {{ progresso }}
      <!-- Progresso -->
      <div class="mb-3">
        <div class="d-flex justify-space-between align-center mb-1">
          <span class="text-body-2 font-weight-medium">Progresso</span>
          <span class="text-h6 font-weight-bold" :class="getCorProgressoClass(progresso)">
            {{ progresso.toFixed(0) }}%
          </span>
        </div>
        <v-progress-linear
          :model-value="progresso"
          :color="getCorProgresso(progresso)"
          height="8"
          rounded
          striped
        />
      </div>

      <!-- Informações Adicionais -->
      <v-row dense class="mb-3">
        <v-col cols="6">
          <div class="text-caption grey--text">Prazo</div>
          <div
            class="text-body-2 font-weight-medium"
            :class="{ 'error--text': ordem.atrasada }"
          >
            {{ formatarData(ordem.prazo_entrega_formatado) }}
          </div>
        </v-col>
        <v-col cols="6">
          <div class="text-caption grey--text">Prioridade</div>
          <v-chip
            :color="getCorPrioridade(ordem.prioridade)"
            size="x-small"
          >
            {{ formatarPrioridade(ordem.prioridade) }}
          </v-chip>
        </v-col>
      </v-row>

      <!-- Setores Envolvidos -->
      <div v-if="ordem.setores && ordem.setores.length > 0" class="mb-3">
        <div class="text-caption grey--text mb-1">Setores</div>
        <div class="d-flex flex-wrap gap-1">
          <v-chip
            v-for="setor in ordem.setores.slice(0, 3)"
            :key="setor"
            size="x-small"
            color="blue-grey"
            variant="outlined"
          >
            {{ setor }}
          </v-chip>
          <v-chip
            v-if="ordem.setores.length > 3"
            size="x-small"
            color="grey"
            variant="outlined"
          >
          +{{ ordem.setores.length - 3 }} mais
        </v-chip>
      </div>
    </div>

    <!-- Métricas Rápidas -->
    <div class="metricas-rapidas">
      <v-row dense>
        <v-col cols="4">
          <div class="text-center pa-2 bg-grey-lighten-5 rounded">
            <div class="text-caption grey--text">Total Pcs</div>
            <div class="text-subtitle-2 font-weight-bold">
              {{ ordem.quantidade_total || 0 }}
            </div>
          </div>
        </v-col>
        <v-col cols="4">
          <div class="text-center pa-2 bg-grey-lighten-5 rounded">
            <div class="text-caption grey--text">Produzido</div>
            <div class="text-subtitle-2 font-weight-bold success--text">
              {{ ordem.quantidade_produzida || 0 }}
            </div>
          </div>
        </v-col>
        <v-col cols="4">
          <div class="text-center pa-2 bg-grey-lighten-5 rounded">
            <div class="text-caption grey--text">Restante</div>
            <div class="text-subtitle-2 font-weight-bold warning--text">
              {{ (ordem.quantidade_total || 0) - (ordem.quantidade_produzida || 0) }}
            </div>
          </div>
        </v-col>
      </v-row>




      <v-row dense>
        <v-col cols="4">
          <div class="text-center pa-2 bg-grey-lighten-5 rounded">
            <div class="text-caption grey--text">Processos</div>
            <div class="text-subtitle-2 font-weight-bold">
              {{ ordem.quantidade_total_processos || 0 }}
            </div>
          </div>
        </v-col>
        <v-col cols="4">
          <div class="text-center pa-2 bg-grey-lighten-5 rounded">
            <div class="text-caption grey--text">Produzido</div>
            <div class="text-subtitle-2 font-weight-bold success--text">
              {{ ordem.quantidade_total_processos_concluidos || 0 }}
            </div>
          </div>
        </v-col>
        <v-col cols="4">
          <div class="text-center pa-2 bg-grey-lighten-5 rounded">
            <div class="text-caption grey--text">Restante</div>
            <div class="text-subtitle-2 font-weight-bold warning--text">
              {{ (ordem.quantidade_total_processos || 0) - (ordem.quantidade_total_processos_concluidos || 0) }}
            </div>
          </div>
        </v-col>
      </v-row>


    </div>
  </v-card-text>

  <!-- Ações -->
  <v-card-actions class="pa-4 pt-0">
    <v-btn
      variant="outlined"
      size="small"
      @click.stop="$emit('ver-detalhes', ordem)"
      class="flex-grow-1"
    >
      <v-icon left size="16">mdi-eye</v-icon>
      Ver Detalhes
    </v-btn>

    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn
          icon
          size="small"
          variant="text"
          v-bind="props"
          @click.stop
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="editarOrdem">
          <template v-slot:prepend>
            <v-icon>mdi-pencil</v-icon>
          </template>
          <v-list-item-title>Editar</v-list-item-title>
        </v-list-item>
        <v-list-item @click="duplicarOrdem">
          <template v-slot:prepend>
            <v-icon>mdi-content-copy</v-icon>
          </template>
          <v-list-item-title>Duplicar</v-list-item-title>
        </v-list-item>
        <v-list-item @click="gerarRelatorio">
          <template v-slot:prepend>
            <v-icon>mdi-file-chart</v-icon>
          </template>
          <v-list-item-title>Relatório</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-card-actions>
</v-card>
</template>

<script>
export default {
name: 'OrdemCard',
props: {
  ordem: {
    type: Object,
    required: true
  }
},

computed: {
  progresso() {
    if (!this.ordem.quantidade_total_processos || this.ordem.quantidade_total_processos === 0) return 0;
    const produzida = this.ordem.quantidade_total_processos_concluidos || 0;
    return Math.round((produzida / this.ordem.quantidade_total_processos) * 100);
  }
},

methods: {
  obterNomeProduto(ordem) {
    // CORREÇÃO DO PROBLEMA "produto não informado"
    if (ordem.produto && ordem.produto !== 'não informado' && ordem.produto.trim() !== '') {
      return ordem.produto;
    }

    if (ordem.nome_produto && ordem.nome_produto !== 'não informado' && ordem.nome_produto.trim() !== '') {
      return ordem.nome_produto;
    }

    if (ordem.descricao_produto && ordem.descricao_produto !== 'não informado' && ordem.descricao_produto.trim() !== '') {
      return ordem.descricao_produto;
    }

    if (ordem.item && ordem.item !== 'não informado' && ordem.item.trim() !== '') {
      return ordem.item;
    }

    // Se realmente não tem produto, mostrar algo mais útil
    return `Produto da Ordem #${ordem.id_ordem || ordem.id}`;
  },

  getCorStatus(status) {
    const cores = {
      'pendente': 'orange',
      'em_andamento': 'blue',
      'iniciada': 'info',
      'concluida': 'green',
      'cancelada': 'red'
    };
    return cores[status] || 'grey';
  },

  formatarStatus(status) {
    const statusMap = {
      'pendente': 'Pendente',
      'em_andamento': 'Em Andamento',
      'iniciada': 'Iniciada',
      'concluida': 'Concluída',
      'cancelada': 'Cancelada'
    };
    return statusMap[status] || status;
  },

  getCorProgresso(progresso) {
    if (progresso >= 80) return 'success';
    if (progresso >= 60) return 'info';
    if (progresso >= 40) return 'warning';
    return 'error';
  },

  getCorProgressoClass(progresso) {
    if (progresso >= 80) return 'success--text';
    if (progresso >= 60) return 'info--text';
    if (progresso >= 40) return 'warning--text';
    return 'error--text';
  },

  getCorPrioridade(prioridade) {
    if (prioridade <= 3) return 'error';
    if (prioridade <= 6) return 'warning';
    if (prioridade <= 10) return 'info';
    return 'grey';
  },

  formatarPrioridade(prioridade) {
    if (!prioridade) return 'Não definida';
    if (prioridade <= 3) return 'Alta';
    if (prioridade <= 6) return 'Média';
    if (prioridade <= 10) return 'Baixa';
    return 'Muito Baixa';
  },

  formatarData(data) {
    if (!data) return 'Não definido';

    // Se já está formatado, retorna como está
    if (typeof data === 'string' && data.includes('/')) {
      return data;
    }

    try {
      return new Date(data).toLocaleDateString('pt-BR');
    } catch (error) {
      return 'Data inválida';
    }
  },

  editarOrdem() {
    this.$emit('editar', this.ordem);
  },

  duplicarOrdem() {
    this.$emit('duplicar', this.ordem);
  },

  gerarRelatorio() {
    this.$emit('relatorio', this.ordem);
  }
}
}
</script>
